import { GridCellProps } from "@progress/kendo-react-grid";
import { TextBoxCell } from "../Layout/Grid/Cell/Default/TextBoxCell";
import { ReadOnlyProps } from "../Project/EditProject/ReadOnlyProps";

export const UppercaseCell = ({ isReadOnly, ...props }: GridCellProps & ReadOnlyProps) => (
  <TextBoxCell uppercase {...props} isReadOnly={isReadOnly} />
);
